import { init as initMessageBox } from '../../MessageBox/js/messageBox';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';
import view from './inputView';

function getMessageObject($markup) {
    var messageObject = common.jsonData($markup, 'message', {
        type: 'no-message',
        message: undefined
    });
    return messageObject;
}

function getEventTypesByDevice() {
    return common.isTouchDevice()
        ? 'click tap'
        : 'mouseenter mouseleave';
}

function getInputContent($markup) {
    return $markup.parent();
}

function getInputContainer($markup) {
    var $content = getInputContent($markup);
    return $content.parent();
}

function createMessageIcon($markup) {
    var $content = getInputContent($markup),
        $messageIcon = $(view.inputMessageIcon);
    $content.after($messageIcon);
}

function getMessageIcon($markup) {
    var $view = getInputContainer($markup);
    return $('.uwr-input-message', $view);
}

// catch message icon focus attempts and redirect them to the input field
function focusRedirectHandler(event) {
    event.target.blur();
    this.focus();
}

function getIE8FocusRedirectHandler($markup) {
    return function (event) {
        event.srcElement.blur();
        $markup.focus();
    };
}

function setMessageIcon($markup, messageObject) {
    var $messageIcon = getMessageIcon($markup),
        messageIconElement = $messageIcon.get(0);

    if (!$messageIcon.length) { return; }

    $messageIcon.attr('class', 'uwr-input-message uwr-input-' + messageObject.type);

    // check if modern browser and capture focus
    if (messageIconElement.addEventListener) {
        messageIconElement.addEventListener('focus', focusRedirectHandler.bind($markup), true);
    } else if (messageIconElement.attachEvent) { // IE8
        // make $markup available in the event handler - no .bind() in IE8
        messageIconElement.attachEvent('onfocus', getIE8FocusRedirectHandler($markup));
    }
}

function createMessageBox($markup) {
    var $messageIcon = getMessageIcon($markup),
        $messageBox = $(view.inputMessageBox);
    $messageIcon.after($messageBox);
}

function getMessageBox($markup) {
    var $container = getInputContainer($markup);
    return $('.uwr-message-box', $container);
}

function getInputIconButton($markup) {
    var container = getInputContainer($markup).get(0);
    return (common.hasClass(container, 'uwr-input-has-button'))
        ? $(container.querySelector('.uwr-input-after'))
        : $();
}

function calcArrowPosition($markup) {
    var $messageBox = getMessageBox($markup),
        $iconButton = getInputIconButton($markup),
        iconButtonWidth = parseInt($iconButton.width(), 10) || 0,
        arrowClass = 'uwr-input-message-box-arrow';
    if (iconButtonWidth > 0) {
        arrowClass = 'uwr-input-message-box-arrow-with-icon-button';
    }
    $messageBox.addClass(arrowClass);
}

function setMessageBox($markup, messageObject) {
    var $messageBox = getMessageBox($markup);
    $messageBox.html(messageObject.message || '');
    // reset message box styles
    $messageBox.attr('class', 'uwr-message-box uwr-message-box-hidden uwr-arrow-top-right');
    $messageBox.data('type', messageObject.type);

    initMessageBox();
    calcArrowPosition($markup);
}

function calcMessageBoxHeight($messageBox) {
    return $messageBox.outerHeight() + 13 + 'px';
}

function setMessageBoxPlaceholder($markup, messageBoxHeight) {
    var $container = getInputContainer($markup);
    $container.css('margin-bottom', messageBoxHeight);
}

function showMessageBox($markup, messageObject) {
    var $messageBox = getMessageBox($markup);
    $messageBox.removeClass('uwr-message-box-hidden');
    if (!messageObject.tooltip || common.isTouchDevice()) {
        setMessageBoxPlaceholder($markup, calcMessageBoxHeight($messageBox));
    }
}

function hideMessageBox($markup) {
    var $messageBox = getMessageBox($markup);
    $messageBox.addClass('uwr-message-box-hidden');
    setMessageBoxPlaceholder($markup, 0);
}

function iconEventHandler(event) {
    if (event.data.$messageBox.is(':visible')) {
        hideMessageBox(event.data.$markup);
    } else {
        showMessageBox(event.data.$markup, event.data.messageObject);
    }
}

function setShowHandlers($markup, messageObject) {
    var $messageIcon = getMessageIcon($markup),
        eventTypes = getEventTypesByDevice();
    $messageIcon.unbind(eventTypes);
    if (messageObject.message) {
        var handlerParams = {
            '$messageBox': getMessageBox($markup),
            '$markup': $markup,
            'messageObject': messageObject
        };
        $messageIcon.bind(
            eventTypes,
            handlerParams,
            iconEventHandler
        );
    }
}

function setMessageBoxMode($markup, messageObject) {
    if (messageObject.tooltip) {
        setShowHandlers($markup, messageObject);
    } else if (messageObject.message) {
        showMessageBox($markup, messageObject);
    } else {
        hideMessageBox($markup);
    }
}

function isElementEmpty($elem) {
    return $elem.length === 0;
}

function initMessageElements($markup) {
    var $messageIcon = getMessageIcon($markup),
        $messageBox = getMessageBox($markup);
    if (isElementEmpty($messageIcon)) {
        createMessageIcon($markup);
    }
    if (isElementEmpty($messageBox)) {
        createMessageBox($markup);
    }
}

function renderMessageBox($markup, messageObject) {
    initMessageElements($markup);
    setMessageIcon($markup, messageObject);
    setMessageBox($markup, messageObject);
    setMessageBoxMode($markup, messageObject);
}

export function message(selector, value) {
    if (value !== undefined && value !== null) {
        var markupNodeList = document.querySelectorAll(selector);
        Array.prototype.forEach.call(markupNodeList, function (markup) {
            var messageObject = common.stringToObject(value) || getMessageObject(markup);
            markup.setAttribute('data-message', common.objectToString(messageObject));
            renderMessageBox($(markup), messageObject);
        });
    }
}

export function init($markup) {
    renderMessageBox($markup, getMessageObject($markup));
}



//////////////////
// WEBPACK FOOTER
// ./widgets/Input/js/inputMessageUtil.js
// module id = 91
// module chunks = main